
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/[account]",
      function () {
        return require("private-next-pages/company/[account]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/[account]"])
      });
    }
  